import { mutations } from "./mutations";
import { getters } from "./getters";
import { actions } from "./actions";
import { WalletState } from "./state";

const defaultState: WalletState = {
  wallets: [],
  currencies: [],
  // withdraws: [],
  // withdraw_states: [],
  prices: [],
};

export const walletModule = {
  state: defaultState,
  mutations,
  actions,
  getters,
};
